import type { CSSProperties, MouseEvent, ReactNode } from "react";
import { Link } from "react-router-dom";

import { ButtonContent, getButtonClassName, type ButtonContentAlign } from "./buttonShared";

type LinkButtonProps = {
    icon?: string;
    disabled?: boolean;
    children?: ReactNode;
    onClick?: (event: MouseEvent<HTMLAnchorElement>) => void;
    className?: string;
    contentAlign?: ButtonContentAlign;
    showArrow?: boolean;
    to: string;
    state?: unknown;
    style?: CSSProperties;
};

export default function LinkButton({
    icon,
    disabled = false,
    children,
    onClick,
    className,
    contentAlign = "left",
    showArrow = true,
    to,
    state,
    style,
}: LinkButtonProps) {
    const buttonClassName = getButtonClassName({ disabled, className, contentAlign });

    const handleClick = (event: MouseEvent<HTMLAnchorElement>) => {
        if (disabled) {
            event.preventDefault();
            return;
        }

        onClick?.(event);
    };

    return (
        <Link
            aria-disabled={disabled}
            className={buttonClassName}
            onClick={handleClick}
            state={state}
            style={style}
            tabIndex={disabled ? -1 : undefined}
            to={to}
        >
            <ButtonContent icon={icon} showArrow={showArrow}>{children}</ButtonContent>
        </Link>
    );
}
